const semanticClassNames = {
  root: 'horizontal-line',
} as const;

export default semanticClassNames;
